import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  ImageModel,
  IStoreImagesStateSuccess,
  IStoreImagesStateError,
} from '@boxx/store-core';
import { Store } from '@ngrx/store';
import * as fromReducer from '../store.reducer';
import * as fromImagesActions from './store-images.action';
import * as fromSelectors from './store-images.selectors';

@Injectable()
export class StoreImagesStore
  implements
    IStoreBase<ImageModel[], IStoreImagesStateSuccess, IStoreImagesStateError>
{
  constructor(public store: Store<fromReducer.IStoreState>) {}

  get loading$() {
    return this.store.select(fromSelectors.getStoreImagesIsLoading);
  }
  get data$() {
    return this.store.select(fromSelectors.getStoreImagesData);
  }
  get fetched$() {
    return this.store.select(fromSelectors.getStoreImagesHasBeenFetched);
  }
  get error$() {
    return this.store.select(fromSelectors.getStoreImagesError);
  }
  get success$() {
    return this.store.select(fromSelectors.getStoreImagesSuccess);
  }

  fetch = () => this.store.dispatch(fromImagesActions.loadImagesBeginAction());

  fetchById = (id: number) =>
    this.store.dispatch(fromImagesActions.loadImageByIdBeginAction({ id }));

  create = (payload: any) =>
    this.store.dispatch(fromImagesActions.createImageBeginAction({ payload }));

  delete = (id: number) =>
    this.store.dispatch(fromImagesActions.deleteImageBeginAction({ id }));
}
